/**
 * Sets the referrer in localStorage if it is not already set
 */
export const setReferrer = () => {
  if (process.env.NODE_ENV === 'development') return
  const ref = getReferrer()
  if (ref) return

  const referrer = document.referrer
  localStorage.setItem('referrer', referrer || 'null')
}

/**
 * Retrieves the referrer from localStorage
 * @returns The stored referrer value, or null if not found
 */
export const getReferrer = () => {
  return localStorage.getItem('referrer')
}

/**
 * Removes the referrer from localStorage
 */
export const removeReferrer = () => {
  localStorage.removeItem('referrer')
}

/**
 * Sets the UTM parameters in localStorage if they are not already set
 */
export const setUMT = () => {
  if (process.env.NODE_ENV === 'development') return
  const { marketing_utm_source, marketing_utm_medium, marketing_utm_campaign, marketing_utm_id } =
    getUMT()
  if (marketing_utm_source || marketing_utm_medium || marketing_utm_campaign || marketing_utm_id)
    return

  const url = new URL(window.location.href)
  const { utm_source, utm_medium, utm_campaign, utm_id } = Object.fromEntries(
    new URLSearchParams(url.search).entries()
  )
  localStorage.setItem('utm_source', utm_source || 'null')
  localStorage.setItem('utm_medium', utm_medium || 'null')
  localStorage.setItem('utm_campaign', utm_campaign || 'null')
  localStorage.setItem('utm_id', utm_id || 'null')
}

/**
 * Retrieves UTM parameters from localStorage
 * @returns Marketing UTM parameters containing source, medium, campaign, and ID
 */
export const getUMT = () => {
  return {
    marketing_utm_source: localStorage.getItem('utm_source'),
    marketing_utm_medium: localStorage.getItem('utm_medium'),
    marketing_utm_campaign: localStorage.getItem('utm_campaign'),
    marketing_utm_id: localStorage.getItem('utm_id')
  }
}

/**
 * Removes the UTM parameters from localStorage
 */
export const removeUMT = () => {
  localStorage.removeItem('utm_source')
  localStorage.removeItem('utm_medium')
  localStorage.removeItem('utm_campaign')
  localStorage.removeItem('utm_id')
}
